import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  orderBy,
} from "firebase/firestore";
import Swal from 'sweetalert2'
const db = getFirestore();

async function filtrarDatos(stringBusqueda, baseDatos, ruc) {
  const docusFiltrado = [];

  const collecionRef = collection(db, baseDatos);
  const queryCodigo = query(
    collecionRef,
    where("codigo", "==", stringBusqueda),
    where("ruc", "==", ruc),
    orderBy("codigo", "desc")
  );

  const arraySnapshots = await Promise.all([
    getDocs(queryCodigo),
  ]);

  arraySnapshots.forEach((snapshot) => {
    snapshot.forEach((doc) => {
      docusFiltrado.push(doc.data());
    });
  });

  if(docusFiltrado.length===0){
    Swal.fire({
      position: 'center',
      icon: 'error',
      title: 'No tiene autorización para ver esta información',
      showConfirmButton: false,
      timer: 2000
    })

    return null;
  } else {
    return docusFiltrado;
  }
  
}

export default filtrarDatos;
